import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const LaravelGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copiedSpecific, setCopiedSpecific] = useState(false);
  const [copiedAll, setCopiedAll] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const fullCode = `<div id="chat-bot-container"></div>\n<script src="https://ezzdesk.com/shared_prompt.js?code=${orgCode}"></script>`;

  const handleCopy = (text, setCopied) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };

  const ImagePlaceholder = () => (
    <div style={{
      width: '100%',
      height: '300px',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      margin: '20px 0',
      color: '#999',
      fontSize: '18px'
    }}>
      Image Placeholder
    </div>
  );

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to Laravel Website
      </h1>
      
      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        Follow this step-by-step guide to add the Ezzdesk widget to your Laravel website. Choose how you want to install your widget below!
      </p>

      <div style={{ background: '#fff3cd', borderLeft: '4px solid #ffecb5', padding: '10px', marginBottom: '30px', fontSize: '14px' }}>
        <strong>Note:</strong> To find out the location of your file manager and Laravel project, please contact your hosting provider. For this guide, we use an example hosting dashboard layout.
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ fontSize: '22px', marginBottom: '15px' }}>Add Widget to Specific Page</h3>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Go to the admin panel of your Laravel website's hosting</strong><br/>
          Log in to the admin panel of your website's hosting and find your file manager.
        </p>
        <img src="/assets/Laravel-1.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Open your Laravel project</strong><br/>
          Find and open your Laravel project folder (often located in a <strong>domains</strong> or similar folder).
        </p>
        <img src="/assets/Laravel-2.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <img src="/assets/Laravel-3.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Find the pages for customization</strong><br/>
          To do this, navigate to the <strong>resources → views</strong> folder:
        </p>
        <img src="/assets/Laravel-4.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <img src="/assets/Laravel-5.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>4. Paste the installation code</strong><br/>
          Click <strong>Edit</strong> next to the needed page (for example, <strong>contact.blade.php</strong>):
        </p>
        <img src="/assets/Laravel-6.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Add the installation code to the place where you want to see the widget:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {fullCode}
          </pre>
          <button
            onClick={() => handleCopy(fullCode, setCopiedSpecific)}
            className='btn-color'
            style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
          >
            {copiedSpecific ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/Laravel-7.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ fontSize: '22px', marginBottom: '15px' }}>Add Widget to All Pages</h3>
        
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Go to the admin panel of your Laravel website's hosting</strong><br/>
          Log in to the admin panel of your website's hosting and find your file manager.
        </p>
        <img src="/assets/Laravel-1.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Open your Laravel project</strong><br/>
          Navigate to your Laravel project folder.
        </p>
        <img src="/assets/Laravel-2.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <img src="/assets/Laravel-3.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Find the pages for customization</strong><br/>
          Navigate to the <strong>resources → views</strong> folder:
        </p>
        <img src="/assets/Laravel-4.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

        <img src="/assets/Laravel-5.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>4. Paste the installation code</strong><br/>
          Click <strong>Edit</strong> next to your root file (for example, <strong>main.blade.php</strong> or <strong>app.blade.php</strong>).
        </p>
        <img src="/assets/file-y9KVLBQEpc.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          Add the installation code right after the opening <code>&lt;body&gt;</code> tag:
        </p>

        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{
            background: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontFamily: 'Courier New, monospace',
            fontSize: '14px',
            overflowX: 'auto'
          }}>
            {fullCode}
          </pre>
          <button
            onClick={() => handleCopy(fullCode, setCopiedAll)}
            className='btn-color'
            style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}
          >
            {copiedAll ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/Laravel-7.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />

      </div>

      <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', borderLeft: '4px solid #007BFF' }}>
        <h4 style={{ margin: '0 0 10px 0', fontSize: '16px' }}>Need Help?</h4>
        <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>
          If you encounter any issues while installing the widget, feel free to contact our support team.
        </p>
      </div>
    </div>
  );
};

export default LaravelGuide;
